(() => {
  'use strict';
  const compact = (v)=>String(v||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
  function prefixNode(node, brand){
    if(!node||!brand)return;
    const txt=compact(node.textContent);
    if(txt.includes(compact(brand)))return;
    const b=document.createElement('span'); b.className='nord-product-brand'; b.textContent=brand;
    const s=document.createElement('span'); s.className='nord-product-title-separator'; s.textContent=' · ';
    node.prepend(s); node.prepend(b);
  }
  function apply(scope=document){
    const cards=[];
    if(scope.matches?.('product-card[data-nord-brand]'))cards.push(scope);
    scope.querySelectorAll?.('product-card[data-nord-brand]').forEach(x=>cards.push(x));
    cards.forEach(card=>{
      const brand=String(card.dataset.nordBrand||'').trim();
      if(!brand)return;
      const candidates=[
        card.querySelector('[ref="productTitleLink"] [role="heading"]'),
        card.querySelector('.nord-product-title-with-brand'),
        card.querySelector('.product-card-gallery__title-placeholder .title-text'),
        card.querySelector('.product-card__content [role="heading"]')
      ].filter(Boolean);
      candidates.forEach(n=>prefixNode(n,brand));
    });
    // Product page fallback.
    const bodyBrand=String(document.body?.dataset?.nordProductVendor||'').trim();
    if(bodyBrand){
      const h1=document.querySelector('main h1, #MainContent h1');
      prefixNode(h1,bodyBrand);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>apply()); else apply();
  new MutationObserver(ms=>ms.forEach(m=>m.addedNodes.forEach(n=>{if(n.nodeType===1)apply(n);}))).observe(document.documentElement,{childList:true,subtree:true});
})();
